/** CSS class for engine-type badges (evm / stellar / solana / …). */
export function engineTypeBadgeClass(type?: string | null): string {
  const normalized = (type || '').trim().toLowerCase();
  switch (normalized) {
    case 'evm':
      return 'dash-badge dash-badge-evm';
    case 'stellar':
      return 'dash-badge dash-badge-stellar';
    case 'solana':
      return 'dash-badge dash-badge-solana';
    default:
      return 'dash-badge dash-badge-accent';
  }
}
